import { put, call } from "redux-saga/effects";
import {
  adminStatesConstants,
  alertConstants,
  authConstants,
} from "_constants";
import {
  adminStatesService,
} from "_services";

export function* getAllStatesSaga() {
  try {
    const states = yield call(adminStatesService.getAllStates);
    const zipcodes = yield call(adminStatesService.getAllZipCodes);

    yield put({
      type: adminStatesConstants.GET_ALL_STATES_SUCCESS,
      payload: [...states],
    });

    yield put({
      type: adminStatesConstants.GET_ALL_ZIPCODES_SUCCESS,
      payload: zipcodes,
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }

    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}